import {CSSProperties, ReactElement, useEffect, useState} from "react";

const FADE_IN_MS  = 250;
const FADE_OUT_MS = 200;

interface IFade {
    children: ReactElement | ReactElement[]
    onFadeOut: () => void
    visible: boolean
}

export function Fade({children, onFadeOut, visible}: IFade) {
    const [opacity, setOpacity] = useState(0);

    useEffect(() => {
        if (visible) {
            // Defer to next paint so the element is in the DOM at opacity 0 first
            const t = requestAnimationFrame(() => setOpacity(1));
            return () => cancelAnimationFrame(t);
        } else {
            setOpacity(0);
            const t = setTimeout(onFadeOut, FADE_OUT_MS);
            return () => clearTimeout(t);
        }
    }, [visible]);

    const style: CSSProperties = {
        opacity,
        transition: `opacity ${visible ? FADE_IN_MS : FADE_OUT_MS}ms linear`
    };

    return <div style={style}>{children}</div>;
}
